'use client';

import {
    AllysAgentsSection,
    AllysContactMapHero,
    AllysContactSection,
    AllysCTASection,
} from '@routeroyal/theme-allys';

type Props = {
  locale: 'en' | 'fr' | 'es';
  messages: Record<string, unknown>;
  basePath: string;
};

export function ContactContentAllys({ locale, messages, basePath }: Props) {
  // Helper to safely get nested string
  const get = (path: string, fallback = ''): string => {
    const keys = path.split('.');
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    let value: any = messages;
    for (const key of keys) {
      value = value?.[key];
      if (value === undefined) return fallback;
    }
    return typeof value === 'string' ? value : fallback;
  };

  return (
    <main className="min-h-screen">
      {/* Hero Section with Map */}
      <AllysContactMapHero
        messages={messages}
        locale={locale}
      />
      
      {/* Combined Contact Section - Contact Info + Form */}
      <AllysContactSection
        messages={messages}
        locale={locale}
      />
      
      {/* Agents Section - Same as home page */}
      <AllysAgentsSection
        messages={messages}
        locale={locale}
      />
      
      {/* CTA Section */}
      <AllysCTASection
        title={get('contact.cta.title', 'Ready to Find Your Perfect Property?')}
        description={get('contact.cta.description', 'Browse our exclusive listings or speak with our expert team')}
        primaryButton={{
          text: get('contact.cta.viewProperties', 'View Properties'),
          href: `${basePath}/properties`,
          variant: 'primary',
        }}
        secondaryButton={{
          text: get('contact.cta.scheduleViewing', 'Schedule a Viewing'),
          href: `${basePath}/contact`,
          variant: 'secondary',
        }}
        maskBackgroundImages={[
          'https://media.routeroyal.com/GdS1cGKCX71Gk6hIKB_5c2EQds5fD3AfXKQLzIkMugA/raw:1/czM6Ly9jb2xsYXBzaWJsZS1wdXJzZS1kbW9rLWRubDd4cy9yb3V0ZXJveWFsL3JveWFsZS9zdGF0aWMvY2MwOTUxYzQ4ZjdiYmYwMWMzYWM5MjdlNjcyYzEyYTk4NGMwYWRjMDhlMmU1ZWYzMjUyYzA4ZDVmNzY0YzhjYy53ZWJw.webp',
          'https://media.routeroyal.com/V_D1ux5wZnx9Uzdbflksb9EGtg1jQ5TwmMVJaVlrwKk/raw:1/czM6Ly9jb2xsYXBzaWJsZS1wdXJzZS1kbW9rLWRubDd4cy9yb3V0ZXJveWFsL3JveWFsZS9zdGF0aWMvMDE1NWIyNjcyOWMyNzZiM2ViZTkwNWIxMmUwNTg0NTUzNWQwODE0OWVhYzYxNGI2ZDcyNzY3NjZjNDg4MmZjMy53ZWJw.webp',
        ]}
        messages={messages}
        locale={locale}
      />
    </main>
  );
}
